import type {TableSortBy2} from '../_old/Table2/Table';

// https://github.com/microsoft/api-guidelines/blob/vNext/Guidelines.md#96-sorting-collections
export function makeApiSortParam(
  sortBy: TableSortBy2 | TableSortBy2[] | null
): string | undefined {
  if (!sortBy) return;

  const construct = (s: TableSortBy2) => {
    const modifier = s.isAsc ? '' : ' desc';
    return s.prop + modifier;
  };

  if (Array.isArray(sortBy)) {
    return sortBy.map(construct).join(',');
  } else {
    return construct(sortBy);
  }
}

export function parseApiSortParam(param = ''): TableSortBy2[] | null {
  const sortStrings = param.split(',');

  if (!sortStrings[0]) return null;

  const sorts = sortStrings.map((s) => {
    const parts = s.split(' ').filter(Boolean);

    const prop = parts[0];
    const isAsc = !parts[1] || parts[1] !== 'desc';

    return {prop, isAsc};
  });

  return sorts;
}
